module.exports = __webpack_public_path__ + "static/Head of Food Safety.b7855fc5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Head of Food Safety.jpg
// module id = 399
// module chunks = 246227742792961